/* global appData */
import { mapState } from 'vuex';

// Scss
import './youtube-video.scss';

// Template and media files
import template from './youtube-video.vhtml';
import playIcon from '../../../_img/icons/icon-play-box.svg';



export default {
	template: template,
	components: {
		playIcon,
	},
	props: {
		videoId: {
			type: String,
			default: '',
		},
		videoLength: {
			type: String,
			default: '',
		},
		thumbnail: {
			type: Object,
			default: null,
		},
	},
	data: () => ({
		playerVars: {
			autoplay: 0,
			rel: 0,
			showinfo: 0,
		},
		player: null,
		isPlaying: false,
		hasLoaded: false,
		initialClick: false,
	}),
	computed: {
		hasId: vm => vm.videoId.length > 0,
		youtubeVideoClasses: vm => ['youtube-video', {
			'youtube-video--transparent-top': !vm.isShown,
		}],
		...mapState({
			isShown: state => state.youtubeVideo.isShown
		}),
	},
	watch: {
		hasLoaded() {
			this.play();
		}
	},
	methods: {
		ready(e) {
			this.player = e.target;
		},
		playing(e) {
			this.hasLoaded = true;
		},
		play() {
			if ( this.initialClick ) {
				this.isPlaying = true;
				setTimeout(() => {
					this.player.playVideo();
				}, 900);
			} else {
				this.initialClick = true;
				this.isPlaying = true;
				this.player.playVideo();
			}
		},
		pause() {
			this.player.pauseVideo();
			this.$options.delayAnimation = setTimeout(() => {
				this.isPlaying = false;
			}, 100);
		},
		buffering() {
			clearTimeout(this.$options.delayAnimation);
		},
		ended() {
			this.isPlaying = false;
		}
	},
};


// WEBPACK FOOTER //
// ./assets/_js/components/youtube-video/youtube-video.js